"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DifferentialExperimentDesign = exports.BaselineExperimentDesign = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactTable = _interopRequireDefault(require("react-table"));

require("react-table/react-table.css");

require("./react-table-custom.css");

var _lodash = require("lodash");

var _pluralize = _interopRequireDefault(require("pluralize"));

var _ExperimentDesignTablePropTypes = _interopRequireDefault(require("./ExperimentDesignTablePropTypes.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

//http://stackoverflow.com/questions/196972/convert-string-to-title-case-with-javascript
var toTitleCase = function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

var aggregateText = function aggregateText(name, vals) {
  var xs = (0, _lodash.uniq)(vals);
  return xs.length === 1 || xs.length < 5 && xs.join(", ").length < 30 ? xs.join(", ") : (0, _pluralize["default"])(name.toLowerCase(), xs.length, true);
};

var ExperimentDesign = function ExperimentDesign(_ref) {
  var data = _ref.data,
      headers = _ref.headers,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
  return /*#__PURE__*/_react["default"].createElement(_reactTable["default"], _extends({
    columns: headers.map(function (headerGroup, ix) {
      return {
        Header: headerGroup.name,
        columns: headerGroup.values.map(function (header, jx) {
          return {
            aggregate: (0, _lodash.curry)(aggregateText, 2)(header),
            Header: header,
            id: ix * 1000 + jx + 1,
            accessor: function accessor(r) {
              return r.values[ix][jx];
            }
          };
        })
      };
    }),
    className: "-striped",
    style: {
      fontSize: "small",
      padding: "7px 0px",
      height: "80%"
    },
    data: data
  }, options));
};

var BaselineExperimentDesign = function BaselineExperimentDesign(_ref2) {
  var data = _ref2.data,
      headers = _ref2.headers;
  return ExperimentDesign({
    data: data.map(function (_ref3) {
      var properties = _ref3.properties,
          values = _ref3.values;
      return {
        values: [[properties.analysed ? "Yes" : "No"]].concat(values)
      };
    }),
    headers: [{
      name: "",
      values: ["Analysed"]
    }].concat(headers)
  });
};

exports.BaselineExperimentDesign = BaselineExperimentDesign;

var DifferentialExperimentDesign = function DifferentialExperimentDesign(_ref4) {
  var data = _ref4.data,
      headers = _ref4.headers;
  return ExperimentDesign({
    data: data.map(function (_ref5) {
      var properties = _ref5.properties,
          values = _ref5.values;
      return {
        values: [[properties.contrastName || "N/A", toTitleCase(properties.referenceOrTest || "")]].concat(values)
      };
    }),
    headers: [{
      name: "",
      values: ["Comparison", "Reference/Test"]
    }].concat(headers),
    options: {
      pivotBy: [1]
    }
  });
};

exports.DifferentialExperimentDesign = DifferentialExperimentDesign;
BaselineExperimentDesign.propTypes = _ExperimentDesignTablePropTypes["default"];
DifferentialExperimentDesign.propTypes = _ExperimentDesignTablePropTypes["default"];
ExperimentDesign.propTypes = _ExperimentDesignTablePropTypes["default"];